module.exports = __webpack_public_path__ + "static/amaunator-symbol-SCAG-bdbbd0dfd978b4c9349da4caf7bc67af.webp";